import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateEmptyContentMessage} from '#core/application/modules/tiles/empty-content-message/index.js';
import {generateEventList} from '#core/application/modules/tiles/event-list/index.js';

import EVENTS_COUPON from './events-coupon.palette-schema.yaml';

registerTileSchema(EVENTS_COUPON);

export function generateEventsCoupon(TILE) {
    return {
        container: {
            style: {
                _mobile_flexDirection: 'column',
            },
        },
        eventListSkeleton: {
            container: {
                style: {
                    padding: 'inherit',
                },
            },
        },
        emptyContent: generateEmptyContentMessage(TILE.EVENTS_COUPON_EMPTY_CONTENT_MESSAGE),
        eventList: generateEventList(TILE.EVENTS_COUPON_EVENT_LIST),
    };
}
